import { FiEye } from "react-icons/fi";
import ModalWrapper from "../UI/ModalWrapper"
import { useState } from "react";
import DescriptionBanner from "../DescriptionBanner";
import { Icon } from "../UI/Icon"
import useDelete from "../../Hooks/useDelete"
import usePatch from "../../Hooks/usePatch"
import API_ENDPOINTS from "../../Config/api";
import ClipLoader from "react-spinners/ClipLoader";
import capitalizeFirstLetter from "../../Utils/capitalizeFirstLetter"
import ConfirmDelete from "../Modal/ConfirmDelete";
import { toast } from 'react-toastify';

export default function FornitoriNonAttiviTable({

  data = [],
  refreshData,
  searchTerm = "",
  statusFilter = "",

}) {

  const filteredData = (data ?? []).filter((item) => {
    const matchText = (item.denominazione ?? "").toLowerCase().includes((searchTerm ?? "").toLowerCase());
    const matchStatus = !statusFilter || (item.stato_contatto ?? "").toLowerCase() === statusFilter;
    return matchText && matchStatus;
  });


  return (
    <div className="flex flex-col h-96 ">
      <div className="flex-1 min-h-0 overflow-y-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
        <table className="w-full table-auto text-sm text-slate-200 border-collapse">
          <colgroup>
            <col className="w-[65%]" />
            <col className="w-[10%]" />
            <col className="w-[15%]" />
            <col className="w-[5%]" />
            <col className="w-[5%]" />
          </colgroup>

          <thead className=" text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
            <tr>
              <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Ragione sociale</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Partita iva</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Stato</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Dettagli</th>
              <th className="px-3 py-5 text-center font-medium whitespace-nowrap"></th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, i) => {
                // if (i === 0)
                return (
                  <Row key={item.id} item={item} refreshData={refreshData} />
                )
              }
              )
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-6 text-slate-400">
                  Nessun fornitore trovato
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}



function Row({

  item,
  refreshData,

}) {

  const { deleteData, loading: deleteLoad } = useDelete()
  const { patchData, loading: patchLoad, error: patchError } = usePatch()

  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)

  const [form, setForm] = useState({

    partita_iva: item.partita_iva ?? "",
    denominazione: item.denominazione ?? "",
    email_riferimento: item.email_riferimento ?? "",
    codice_fiscale: item.codice_fiscale ?? "",
    indirizzo: item.indirizzo ?? "",
    dominio_web: item.dominio_web ?? "",
    telefono: item.telefono ?? "",
    email_contatto: item.email_contatto ?? "",
    nota: item.nota ?? "",
    stato_contatto: item.stato_contatto ?? "",

  });


  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  async function handleSave() {
    try {

      const payload = {};
      for (const k of Object.keys(form)) {
        if ((item[k] ?? "") !== form[k]) {
          payload[k] = form[k] === "" ? null : form[k];
        }
      }

      if (Object.keys(payload).length === 0) {
        setShowEditModal(false);
        return;
      }

      await patchData(API_ENDPOINTS.aggiornaParziale(item.id), payload);

      toast.success(`Modificato con successo`);
      setShowEditModal(false);
      refreshData?.();
    } catch (err) {
      toast.error(`Errore salvataggio: ${err.message}`);
    }
  }


  async function handleCancelButton() {
    try {
      await deleteData(API_ENDPOINTS.cancellaAziendaCaricata(item.id));
      toast.success(`Cancellato con successo`);
      setShowCancelModal(false);
      refreshData()
    } catch (err) {
      console.error(err);
      toast.error(`Errore nella cancellazione: ${err.message}`);
    }
  }


  return (
    <>
      <tr className=" text-black border-white border-b-4 bg-[#E3E3E3]">

        {/* Ragione sociale */}
        <td className="px-3 py-3">
          <p className="font-semibold leading-tight">
            {item.denominazione ?? "--"}
          </p>
        </td>

        {/* Valori */}
        <td className="px-3 py-3 text-center tabular-nums">
          {item.partita_iva ?? "--"}
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          <div
            className={`inline-block px-2 py-1 w-full rounded font-medium text-sm
              ${item.stato_contatto.toLowerCase() === "da attivare" ?
                "bg-blue-100 text-blue-800 border border-blue-400"
                :
                item.stato_contatto.toLowerCase() === "consenso ok" ?
                  "bg-green-100 text-green-800 border border-green-400"
                  :
                  item.stato_contatto.toLowerCase() === "in attesa di consenso" ?
                    "bg-yellow-100 border text-yellow-800 border-yellow-400"
                    :
                    // "bg-red-100 border text-red-800 border-red-400"
                    null
              }`}
          >
            {capitalizeFirstLetter(item.stato_contatto) ?? "--"}
          </div>
        </td>
        <td className="px-3 py-3 text-center tabular-nums">
          {
            <button
              className="p-2 rounded border hover:bg-gray-300 transition"
              onClick={() => setShowDetailsModal(true)}
            >
              <Icon name={'eye'} />
            </button>
            ?? "--"
          }
        </td>
        <td className="px-3 py-3 text-center tabular-nums ">
          <div className="flex items-center gap-2">
            <button onClick={() => setShowEditModal(true)}>
              <Icon name={'edit'} className='active:scale-95 text-gray-500 hover:text-gray-600 duration-300 hover:scale-110 cursor-pointer' />
            </button>
            <button onClick={() => setShowCancelModal(true)}>
              <Icon name={'trash'} className='active:scale-95 text-gray-500 hover:text-gray-600 duration-300 hover:scale-110 cursor-pointer' />
            </button>
          </div>
        </td>

      </tr >

      <ModalWrapper ModalWrapper isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
        <div className="bg-white p-6 rounded">
          <DescriptionBanner title="Dettaglio fornitore" description={form.denominazione || item.denominazione} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-6  text-sm">
            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Email di riferimento</label>
              <p>{item.email_riferimento ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Email contatto</label>
              <p>{item.email_contatto ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Codice fiscale</label>
              <p>{item.codice_fiscale ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Telefono</label>
              <p>{item.telefono ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Indirizzo</label>
              <p>{item.indirizzo ?? '-'}</p>
            </div>

            <div className="w-44">
              <label className="block text-sm text-gray-600 mb-1 font-semibold">Dominio web</label>
              <p>{item.dominio_web ?? '-'}</p>
            </div>

            <div className="md:col-span-3">
              <label className="block text-sm text-gray-600 mb-1  font-semibold">Nota</label>
              <div className="w-full border rounded px-3 py-2 min-h-[84px]">
                <p>{item.nota}</p>
              </div>
            </div>

          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={() => setShowDetailsModal(false)}
              disabled={patchLoad}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded"
            >
              Chiudi
            </button>
          </div>
        </div>
      </ModalWrapper >

      <ModalWrapper isOpen={showEditModal} onClose={() => !patchLoad && setShowEditModal(false)}>
        <div className="bg-white p-6 rounded">
          <DescriptionBanner title="Modifica fornitore" description={form.denominazione || item.denominazione} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6  text-sm">
            <div>
              <label className="block text-sm text-gray-600 mb-1">Ragione sociale</label>
              <input
                name="denominazione"
                value={form.denominazione}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Ragione sociale"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Partita IVA</label>
              <input
                name="partita_iva"
                value={form.partita_iva}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Partita IVA"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Email di riferimento</label>
              <input
                name="email_riferimento"
                value={form.email_riferimento}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="email@esempio.com"
                type="email"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Email contatto</label>
              <input
                name="email_contatto"
                value={form.email_contatto}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="email@contatto.com"
                type="email"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Codice fiscale</label>
              <input
                name="codice_fiscale"
                value={form.codice_fiscale}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Codice fiscale"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Telefono</label>
              <input
                name="telefono"
                value={form.telefono}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Telefono"
              />
            </div>

            <div className="md:col-span-1">
              <label className="block text-sm text-gray-600 mb-1">Indirizzo</label>
              <input
                name="indirizzo"
                value={form.indirizzo}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Indirizzo"
              />
            </div>

            <div className="md:col-span-1">
              <label className="block text-sm text-gray-600 mb-1">Dominio web</label>
              <input
                name="dominio_web"
                value={form.dominio_web}
                onChange={onChange}
                className="w-full border rounded px-3 py-2"
                placeholder="www.esempio.com"
              />
            </div>
          </div>

          {patchError && (
            <div className="mt-3 text-sm text-red-600">
              {patchError.message || "Errore durante l'aggiornamento"}
            </div>
          )}

          <div className="mt-6 flex justify-between">
            <button
              onClick={() => setShowEditModal(false)}
              disabled={patchLoad}
              className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded"
            >
              Annulla
            </button>
            <button
              onClick={handleSave}
              disabled={patchLoad}
              className={`px-4 py-2 rounded text-white flex items-center justify-center gap-2
                ${patchLoad ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
              style={{ width: 112 }} // blocco la larghezza per non far saltare col loader
            >
              {patchLoad ? <ClipLoader size={18} color="#fff" /> : "Salva"}
            </button>
          </div>
        </div>
      </ModalWrapper>

      <ModalWrapper isOpen={showCancelModal} onClose={() => setShowCancelModal(false)}  >
        <ConfirmDelete
          elementNameToDelete={"Conferma cancellazione"}
          message={`Sei sicuro di voler cancellare "${item.denominazione}"?`}
          onConfirm={handleCancelButton}
          onCancel={() => setShowCancelModal(false)}
          confirmLabel="Cancella"
          isLoading={deleteLoad}
        />
      </ModalWrapper>
    </>
  );
}